// extracted by mini-css-extract-plugin
export default {"buttons":"pagination_buttons__amAMZ"};